import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import { DEM_CONFIGURATION_FORM_DATA, DEM_CONNECTION_FORM_DATA } from '@/utils/constants'

const state = {
    isLoading: false,
    notReadyIsLoading: false,
    activeTab: null,
    searchFilters: {
        input: null,
        jsonKeyType: 'job',
        jsonKeyNames: null
    },
    selectedRowId: null,
    activeStep: 0,
    displayModal: false,
    formAction: null,
    formIsValid: {
        connection: false,
        configuration: false
    },
    formConnection: DEM_CONNECTION_FORM_DATA,
    formConfiguration: DEM_CONFIGURATION_FORM_DATA,
    formType: null,
    connectionId: null
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
